import React, { useState } from "react";
import { useIsMobile } from "../../../hooks/useIsMobile.ts";
import { Box, Typography, Grid, IconButton, Button, Card, Slider, Tabs, Tab, Badge } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";

export default function MatchSetResultsTab({ state, dispatch }: any) {
  const isMobile = useIsMobile();
  const [tabSet, setTabSet] = useState(0);
  const currentSet = state.sets[tabSet];

  // Funzione di validazione del set
  // Validazione aggiornata: almeno uno >= 25 e differenza >= 2
  const isSetValid = (set: any) => {
    const maxScore = Math.max(set.teamScore, set.opponentScore);
    const minScore = Math.min(set.teamScore, set.opponentScore);
    return maxScore >= 25 && (maxScore - minScore) >= 2;
  };

  return (
    <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, height: "100%" }}>
      {/* Tabs dei set */}
      <Tabs
        orientation={isMobile ? "horizontal" : "vertical"}
        variant="scrollable"
        scrollButtons="auto"
        value={tabSet}
        onChange={(e, val) => setTabSet(val)}
        sx={{
          borderRight: { xs: 0, sm: 1 },
          borderBottom: { xs: 1, sm: 0 },
          borderColor: "divider",
          minWidth: { xs: "unset", sm: 130 },
        }}
      >
        {state.sets.map((s: any, idx: number) => {
          const valid = isSetValid(s);
          const badge = valid ? "✅" : "❌";

          return (
            <Tab
              key={s.setNumber}
              label={
                <Box sx={{ display: "flex", justifyContent: "space-between", pr: 1 }}>
                  <Typography sx={{ fontWeight: tabSet === idx ? "bold" : "normal" }}>
                    Set {s.setNumber}
                  </Typography>
                  <Badge badgeContent={badge} sx={{ ml: 2, mt: 1 }} />
                </Box>
              }
            />
          );
        })}
      </Tabs>

      {/* Contenuto del set selezionato */}
      <Box sx={{ flex: 1, p: 2 }}>
        {currentSet ? (
          <Card sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Set {currentSet.setNumber} {isSetValid(currentSet) ? "✅ Valid" : "❌ Invalid"}
            </Typography>

            <Grid container spacing={3} alignItems="center">
              {/* Team */}
              <Grid size={{ xs: 12, md: 5 }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: "#1976d2" }}>
                  Team Score: {currentSet.teamScore}
                </Typography>
                <Slider
                  value={currentSet.teamScore}
                  min={0}
                  max={42}
                  step={1}
                  onChange={(e, val) =>
                    dispatch({
                      type: "UPDATE_SET",
                      setNumber: currentSet.setNumber,
                      field: "teamScore",
                      value: val,
                    })
                  }
                  sx={{ color: "#1976d2" }}
                />
              </Grid>

              {/* Opponent */}
              <Grid size={{ xs: 12, md: 5 }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: "#d32f2f" }}>
                  Opponent Score: {currentSet.opponentScore}
                </Typography>
                <Slider
                  value={currentSet.opponentScore}
                  min={0}
                  max={42}
                  step={1}
                  onChange={(e, val) =>
                    dispatch({
                      type: "UPDATE_SET",
                      setNumber: currentSet.setNumber,
                      field: "opponentScore",
                      value: val,
                    })
                  }
                  sx={{ color: "#d32f2f" }}
                />
              </Grid>

              {/* Remove */}
              <Grid size={{ xs: 12, md: 2 }} sx={{ textAlign: "right" }}>
                <IconButton
                  color="error"
                  onClick={() => dispatch({ type: "REMOVE_SET", setNumber: currentSet.setNumber })}
                >
                  <Delete />
                </IconButton>
              </Grid>
            </Grid>
          </Card>
        ) : (
          <Typography>No sets available</Typography>
        )}

        <Box mt={2}>
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => dispatch({ type: "ADD_SET" })}
          >
            Add Set
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
